function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable import/no-cycle */
import React from 'react';
import Chip from '../Chip';
import { styled } from "../styles";
import Stack from "../Stack";
import Link from "../Link";
import StandardTooltip from '../StandardTooltip';
export const ClearButton = styled(Link)(_ref => {
  let {
    theme
  } = _ref;
  return {
    border: "none",
    color: theme.palette.primary.main,
    cursor: "pointer",
    alignItems: "center",
    display: "flex",
    textDecoration: "none",
    fontSize: "14px"
  };
});
const container = {
  flexWrap: "wrap",
  rowGap: "10px",
  columnGap: "10px",
  justifyContent: "flex-start"
};
const ListAppliedFilterChip = _ref2 => {
  let {
    appliedSearchFilters,
    onRemoveSearchFilter,
    onClearAllSearchFilters,
    labelClearAllFilters,
    labelFilters,
    ...restProps
  } = _ref2;
  /* omit can_remove=false from the "clear_all" method */
  const appliedSearchFiltersCanRemove = appliedSearchFilters.filter(searchFilter => searchFilter.can_remove);
  return /*#__PURE__*/React.createElement("div", null, appliedSearchFilters.length > 0 && /*#__PURE__*/React.createElement(Stack, {
    "aria-label": labelFilters,
    direction: "row",
    sx: container
  }, appliedSearchFilters.map(searchFilter => {
    const filterLabels = searchFilter.filterValues.map(values => " ".concat(values.label !== undefined ? values.label : values.value));
    const hasFilterLabels = searchFilter.filterValues.length > 0;
    return hasFilterLabels && /*#__PURE__*/React.createElement(StandardTooltip, {
      title: "".concat(filterLabels),
      key: searchFilter.searchFilterId
    }, /*#__PURE__*/React.createElement(Chip, _extends({
      label: searchFilter.displayLabel,
      onClick: () => {},
      onDelete: searchFilter.can_remove !== false ? () => onRemoveSearchFilter({
        appliedSearchFilter: searchFilter
      }) : null,
      key: searchFilter.searchFilterId
    }, restProps)));
  }), /*#__PURE__*/React.createElement(ClearButton, {
    onClick: () => onClearAllSearchFilters({
      appliedSearchFilters: appliedSearchFiltersCanRemove
    })
  }, labelClearAllFilters)));
};
export default ListAppliedFilterChip;